export default {
  badge: 'Значка',
  open: 'Отвори',
  close: 'Затвори',
  dismiss: 'Одбаци',
  confirmEdit: {
    ok: 'У реду',
    cancel: 'Откажи',
  },
  dataIterator: {
    noResultsText: 'Ни један запис није пронађен',
    loadingText: 'Учитавање ставке...',
  },
  dataTable: {
    itemsPerPageText: 'Редова по страници:',
    ariaLabel: {
      sortDescending: 'Сортирано опадајуће.',
      sortAscending: 'Сортирано растуће.',
      sortNone: 'Није сортирано.',
      activateNone: 'Кликни да уклониш сортирање.',
      activateDescending: 'Кликни да сортираш опадајуће.',
      activateAscending: 'Кликни да сортираш растуће.',
      selectRow: 'Изабери ред',
      selectAll: 'Изабери све',
      selectGroup: 'Изабери групу',
    },
    sortBy: 'Сортирај по',
  },
  dataFooter: {
    itemsPerPageText: 'Ставки по страници:',
    itemsPerPageAll: 'Све',
    nextPage: 'Следећа страница',
    prevPage: 'Претходна страница',
    firstPage: 'Прва страница',
    lastPage: 'Последња страница',
    pageText: '{0}-{1} од {2}',
  },
  dateRangeInput: {
    divider: 'до',
  },
  monthPicker: {
    title: 'Изаберите месец',
    itemsSelected: '{0} изабрано',
    header: 'Унесите месец',
    range: {
      title: 'Унесите месеце',
    },
    ariaLabel: {
      previousYear: 'Претходна година',
      nextYear: 'Следећа година',
      selectYear: 'Select year',
      currentMonth: 'Тренутни месец, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} изабрано',
    range: {
      title: 'Изаберите датуме',
      header: 'Унесите датуме',
    },
    title: 'Изаберите датум',
    header: 'Унесите датум',
    input: {
      placeholder: 'Унесите датум',
    },
    ariaLabel: {
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      selectYear: 'Select year',
      previousYear: 'Претходна година',
      nextYear: 'Следећа година',
      selectMonth: 'Изаберите месец',
      selectDate: '{0}',
      currentDate: 'Today, {0}',
    },
  },
  noDataText: 'Нема доступних података',
  carousel: {
    prev: 'Претходна слика',
    next: 'Следећа слика',
    ariaLabel: {
      delimiter: 'Слика {0} од {1}',
    },
  },
  calendar: {
    moreEvents: '{0} више',
    today: 'Данас',
  },
  heatmap: {
    less: 'Мање',
    more: 'Више',
  },
  input: {
    clear: 'Очисти {0}',
    prependAction: '{0} претходна акција',
    appendAction: '{0} додатна акција',
    otp: 'Унесите код за потврду',
  },
  fileInput: {
    counter: '{0} фајлова',
    counterSize: '{0} фајлова ({1} укупно)',
  },
  fileUpload: {
    title: 'Превуците и отпустите фајлове овде',
    divider: 'или',
    browse: 'Прегледај фајлове',
  },
  timePicker: {
    am: 'АМ',
    pm: 'ПМ',
    title: 'Изаберите време',
    hour: 'Сат',
    minute: 'Минути',
    second: 'Секунде',
    notAllowed: 'Вредност није дозвољена',
  },
  pagination: {
    ariaLabel: {
      root: 'Навигација страницама',
      next: 'Следећа страница',
      previous: 'Претходна страница',
      page: 'Иди на страницу {0}',
      currentPage: 'Тренутна страница, страница {0}',
      first: 'Прва страница',
      last: 'Последња страница',
    },
  },
  stepper: {
    next: 'Следеће',
    prev: 'Претходно',
  },
  rating: {
    ariaLabel: {
      item: 'Оцена {0} од {1}',
    },
  },
  loading: 'Учитавање...',
  infiniteScroll: {
    loadMore: 'Учитај више',
    empty: 'Нема више података',
  },
  rules: {
    required: 'Ово поље је обавезно',
    email: 'Унесите важећу е-маил адресу',
    number: 'Ово поље може садржати само бројеве',
    integer: 'Ово поље може садржати само целе бројеве',
    capital: 'Ово поље може садржати само велика слова',
    maxLength: 'Морате унети максимум {0} карактера',
    minLength: 'Морате унети минимум {0} карактера',
    strictLength: 'Дужина унетог поља није важећа',
    exclude: 'Карактер {0} није дозвољен',
    notEmpty: 'Изаберите бар једну вредност',
    pattern: 'Неважећи формат',
  },
  command: {
    search: 'Унесите команду или претражите...',
  },
  hotkey: {
    then: 'затим',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Стрелица нагоре',
    downArrow: 'Стрелица надоле',
    leftArrow: 'Стрелица налево',
    rightArrow: 'Стрелица надесно',
    backspace: 'Backspace',
    space: 'Размак',
    plus: 'плус',
    shortcut: 'Пречица на тастатури: {0}',
    or: 'или',
  },
  video: {
    play: 'Пусти',
    pause: 'Паузирај',
    seek: 'Тражи',
    volume: 'Јачина звука',
    showVolume: 'Прикажи контролу јачине звука',
    mute: 'Искључи звук',
    unmute: 'Укључи звук',
    enterFullscreen: 'Цео екран',
    exitFullscreen: 'Изађи из целог екрана',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Изаберите боју са екрана',
      hueSlider: 'Нијанса',
      alphaSlider: 'Алфа',
      redInput: 'Црвена',
      greenInput: 'Зелена',
      blueInput: 'Плава',
      alphaInput: 'Алфа',
      hueInput: 'Нијанса',
      saturationInput: 'Засићеност',
      lightnessInput: 'Осветљеност',
      hexInput: 'ХЕКС вредност',
      hexaInput: 'ХЕКС са алфа вредношћу',
      changeFormat: 'Промени формат боје',
    },
  },
}
